// extracted by mini-css-extract-plugin
export default {"opportunity-doc-holder":"OpportunityDoc_opportunity-doc-holder__TuJo3","image-banner":"OpportunityDoc_image-banner__X6Vhb"};